import {
  doc,
  getDoc,
  updateDoc,
  Timestamp
} from 'firebase/firestore';
import { db } from '../config/firebase';
import {
  Currency,
  OrganizationCurrencySettings,
  SUPPORTED_CURRENCIES
} from '../types/currency';

const ORGANIZATIONS_COLLECTION = 'organizations';

class CurrencyService {
  // Récupérer les paramètres de devise d'une organisation
  async getOrganizationCurrencySettings(
    organizationId: string
  ): Promise<OrganizationCurrencySettings> {
    try {
      const orgDoc = await getDoc(doc(db, ORGANIZATIONS_COLLECTION, organizationId));
      const orgData = orgDoc.data();
      
      if (!orgData?.currencySettings) {
        // Paramètres par défaut si non définis
        const defaultCurrency = SUPPORTED_CURRENCIES[0];
        return {
          defaultCurrency: defaultCurrency.code,
          decimalSeparator: defaultCurrency.decimalSeparator,
          thousandsSeparator: defaultCurrency.thousandsSeparator,
          symbolPosition: defaultCurrency.position
        };
      }
      
      return orgData.currencySettings as OrganizationCurrencySettings;
    } catch (error) {
      console.error('Erreur lors de la récupération des paramètres de devise:', error);
      throw error;
    }
  }

  // Mettre à jour les paramètres de devise d'une organisation
  async updateOrganizationCurrencySettings(
    organizationId: string,
    settings: OrganizationCurrencySettings
  ): Promise<void> {
    try {
      await updateDoc(doc(db, ORGANIZATIONS_COLLECTION, organizationId), {
        currencySettings: settings,
        updatedAt: Timestamp.now()
      });
    } catch (error) {
      console.error('Erreur lors de la mise à jour des paramètres de devise:', error);
      throw error;
    }
  }

  // Obtenir la devise par son code
  getCurrencyByCode(code: string): Currency | undefined {
    return SUPPORTED_CURRENCIES.find(currency => currency.code === code);
  }

  // Obtenir toutes les devises supportées
  getSupportedCurrencies(): Currency[] {
    return SUPPORTED_CURRENCIES;
  }
}

export const currencyService = new CurrencyService();